import ActionTypes from "../../../constants/ActionTypes";
import { ISetCaptchaRequiredActions } from "./types";

export const callLastRequest = (token: any) => ({
  type: `${ActionTypes.CAPTCHA.CALL_LAST_REQUEST}`,
  payload: token,
});

export const setCaptchaRequiredActions = (isCaptchaRequired: boolean, entity: string): ISetCaptchaRequiredActions => ({
  type: `${ActionTypes.SET_CAPTCHA_REQUIRED}`,
  payload: { isCaptchaRequired, entity }
});
